// extracted by mini-css-extract-plugin
module.exports = {"not-found-wrapper":"NotFound_not-found-wrapper__3jIXq","not-found-left":"NotFound_not-found-left__113xy","not-found-right":"NotFound_not-found-right__1jaK6"};